import { selectricInit } from '../utils/selectric';

let isFirstLoad = true;
const hasProduct = $('.template-product').length && $('#product-select').length && !$('#product-select').hasClass('js-product-has-only-default-variant');

const onVariantSelected = (variant, selector) => {
  $(selector.variantIdField)
    .closest('form')
    .find('button[type="submit"]')
    .prop('disabled', !variant.available)
    .toggleClass('is-hidden', !variant.available);

  if (isFirstLoad) {
    selector.selectors.forEach((selector) => {
      selectricInit($(selector.element), {
        labelBuilder: `<strong>${Shopify.theme.locale.products.product.select} ${selector.name}:</strong> {value}`,
      });
    });
  }

  if (!isFirstLoad) {
    const variantPriceHtml = $(selector.variantIdField)
      .find(`option[value="${variant.id}"]`)
      .data('price');

    $('.js-product-price').html(variantPriceHtml);

    if (variant.available) {
      $('.js-quantity-col').removeClass('hidden');
    } else {
      $('.js-quantity-col').addClass('hidden');
    }
  }

  isFirstLoad = false;
};

const initOptionSelectors = (product = Shopify.product, selector = 'product-select', enableHistoryState = true) => {
  new Shopify.OptionSelectors(selector, { product, enableHistoryState, onVariantSelected });
};

if (hasProduct) {
  initOptionSelectors();

  $(window).on('shopify:section:load', function () {
    initOptionSelectors();
  });
}
